$(document).ready(function(){
        
	$('.productSlider').bxSlider();
  
	$('.nutrifacts').appendTo('#CollapsibleAccordion-16505236024613949f-1-template--14575820767274__1650523602fb78847b');
    
});


$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 800);
});